import { render, staticRenderFns } from "./inventoryBuy.vue?vue&type=template&id=3db6c250&scoped=true&"
import script from "./inventoryBuy.vue?vue&type=script&lang=js&"
export * from "./inventoryBuy.vue?vue&type=script&lang=js&"
import style0 from "./inventoryBuy.vue?vue&type=style&index=0&id=3db6c250&lang=less&scoped=true&"
import style1 from "./inventoryBuy.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6c250",
  null
  
)

component.options.__file = "inventoryBuy.vue"
export default component.exports